import Project1Img from "../Images/project-1.png";
import Project2Img from "../Images/project-2.png";
import Project3Img from "../Images/project-3.png";
import Project4Img from "../Images/project-4.png";
import Project5Img from "../Images/project-5.png";

// Fallback abstract imagery, cycled for any project without a placeholder image.
const images = [Project1Img, Project2Img, Project3Img, Project4Img, Project5Img];

// Real thumbnails in public/placeholder/, matched to each project by slug.
// (filenames/extensions vary, so they are mapped explicitly.)
const placeholderFiles = {
  "holm-experiences": "holm-experiences.png",
  "central-avenue": "central-avenue.jpg",
  "central-hills": "central-hills.jpg",
  "casa-beyt": "casabeyt.jpg",
  "immo-value-capital": "immo-value-capital.webp",
  "green-lotus": "green-lotus.jpg",
  "intenda-studio": "intenda-studio.png",
};

const projects = [
  {
    slug: "holm-experiences",
    name: "Holm Experiences",
    url: "https://holm-experiences.com",
    category: "experience",
    role: "web design & development",
    year: "2024",
    description:
      "Immersive marketing website for an experiential hospitality brand. Designed and built from the ground up with a focus on storytelling, motion and a fast, responsive front end.",
  },
  {
    slug: "central-avenue",
    name: "Central Avenue",
    url: "https://centralavenue.ma",
    category: "real estate",
    role: "web design & development",
    year: "2023",
    description:
      "Showcase website for a premium residential development. Property presentation, gallery and enquiry journeys built for a polished, high-end feel across every screen size.",
  },
  {
    slug: "central-hills",
    name: "Central Hills",
    url: "https://centralhills.ma",
    category: "real estate",
    role: "web design & development",
    year: "2023",
    description:
      "Landing and showcase site for a residential real-estate project. Clean, image-led layout engineered to convert visitors into qualified leads.",
  },
  {
    slug: "casa-beyt",
    name: "Casa Beyt",
    url: "https://casabeyt.ma",
    category: "real estate",
    role: "web master & development",
    year: "2024",
    description:
      "Real-estate platform presenting projects and listings for a Casablanca-based developer. Built as a maintainable, content-driven website.",
  },
  {
    slug: "immo-value-capital",
    name: "Immo Value Capital",
    url: "https://immovaluecapital.com",
    category: "corporate",
    role: "web design & development",
    year: "2024",
    description:
      "Corporate website for a real-estate investment firm. Structured to communicate trust, strategy and portfolio at a glance.",
  },
  {
    slug: "green-lotus",
    name: "Green Lotus",
    url: "https://greenlotus.ma",
    category: "brand",
    role: "web design & development",
    year: "2022",
    description:
      "Brand website with a calm, refined identity carried through typography, spacing and motion. Fully responsive and built for easy content updates.",
  },
  {
    slug: "lap-electric",
    name: "Lap Electric",
    url: "https://lap-electric.ma",
    category: "industrial",
    role: "web design & development",
    year: "2022",
    description:
      "Corporate site for an electrical engineering company. Presents services and projects with a clear, professional and dependable tone.",
  },
  {
    slug: "intenda-studio",
    name: "Intenda Studio",
    url: "https://intendastudio.com",
    category: "studio",
    role: "web master & development",
    year: "2023",
    description:
      "Studio website for the creative agency. Built to present work, services and the team behind the projects with a strong, expressive identity.",
  },
  {
    slug: "az-input",
    name: "AZ Input",
    url: "https://azinput.com",
    category: "digital",
    role: "web design & development",
    year: "2023",
    description:
      "Digital platform website with a modern, product-focused presentation. Built for performance and scalability across devices.",
  },
  {
    slug: "cps-top-100",
    name: "CPS Top 100",
    url: "https://cpstop100.com",
    category: "event",
    role: "web master & development",
    year: "2024",
    description:
      "Event and ranking website presenting a curated Top 100. Data-driven layout designed to be browsed quickly and shared widely.",
  },
].map((project, index) => ({
  ...project,
  // Works-section thumbnail: real placeholder image when available, else fallback
  image: placeholderFiles[project.slug]
    ? `${process.env.PUBLIC_URL}/placeholder/${placeholderFiles[project.slug]}`
    : images[index % images.length],
  // full-page screenshot of the live site, used as the preview poster / fallback
  preview: `${process.env.PUBLIC_URL}/previews/site-${project.slug}.jpg`,
}));

export const getProject = (slug) =>
  projects.find((project) => project.slug === slug);

export default projects;
